module.exports = __webpack_public_path__ + "img/Empty Order.c9d33bed.png";